import { isContentFragment } from './content-fragment';
export function isFeatureApp(item) {
    var _a, _b, _c, _d, _e;
    return (isContentFragment(item) &&
        Boolean((_a = item.model) === null || _a === void 0 ? void 0 : _a.metadata) &&
        ((_c = (_b = item.model) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.src) !== undefined &&
        ((_e = (_d = item.model) === null || _d === void 0 ? void 0 : _d.metadata) === null || _e === void 0 ? void 0 : _e.id) !== undefined);
}
//# sourceMappingURL=feature-app.js.map